const isAccountPage = (router) => router.pathname.includes('/account/');

export default isAccountPage;
